import React, { useEffect, useState } from 'react';
import { useSubmissionsContext } from '../../../context/submissions';
import FilterValueItem from './FilterValueItem';
import FilterSearchInput from 'components/molecules/FilterSearchInput';

const FilterValues = ({
  openDropdown,
  closeFilterDropdown,
  selectedField,
  optionsLabelMapping
}) => {
  const { filters, updateFilters, filtersOptions } = useSubmissionsContext();
  const [filteredValues, setFilteredValues] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [filterText, setFilterText] = useState('');

  const selectedValues = filters[selectedField] || [];

  const getDisplayLabel = (value) => {
    return optionsLabelMapping?.[value] ?? value;
  };

  const handleInputChange = (e) => {
    setFilterText(e.target.value);
  };

  const handleCheckboxChange = (value) => {
    const isAlreadySelected = selectedValues.includes(value);
    const newValues = isAlreadySelected
      ? selectedValues.filter((val) => val !== value)
      : [...selectedValues, value];

    const operator = newValues.length > 1 ? 'is any of' : 'is';
    updateFilters(selectedField, operator, newValues);
  };

  const handleValueClick = (value) => {
    updateFilters(selectedField, 'is', value);
    closeFilterDropdown();
  };

  const handleKeyDown = (e) => {
    const length = filteredValues.length;

    switch (e.key) {
      case 'Escape':
        closeFilterDropdown();
        break;
      case 'Enter':
        if (highlightedIndex >= 0) {
          handleValueClick([filteredValues[highlightedIndex]]);
        }
        break;
      case 'ArrowDown':
        e.preventDefault();
        setHighlightedIndex((prev) => (prev + 1) % length);
        break;
      case 'ArrowUp':
        e.preventDefault();
        setHighlightedIndex((prev) => (prev - 1 + length) % length);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (openDropdown) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [openDropdown, filteredValues, highlightedIndex]);

  useEffect(() => {
    const options = filtersOptions[selectedField] || [];
    const filtered = options.filter((val) =>
      getDisplayLabel(val).toLowerCase().includes(filterText.toLowerCase())
    );

    setFilteredValues(filtered);

    const matchIndex = filtered.findIndex((val) =>
      getDisplayLabel(val).toLowerCase().startsWith(filterText.toLowerCase())
    );
    setHighlightedIndex(matchIndex !== -1 ? matchIndex : -1);
  }, [filterText, selectedField, filtersOptions]);

  return (
    <div className="bg-[#2c2d33] border border-[#85869833] rounded-md shadow">
      <FilterSearchInput
        value={filterText}
        onChange={handleInputChange}
        autoFocus
        placeholder="Filter"
        id="filter-value-dropdown-input"
        icon="F"
      />
      <ul className="flex flex-col m-1 max-h-[60vh] overflow-auto">
        {filteredValues.map((value, index) => (
          <FilterValueItem
            key={value}
            value={value}
            label={getDisplayLabel(value)}
            isSelected={selectedValues.includes(value)}
            isHighlighted={highlightedIndex === index}
            onMouseEnter={() => setHighlightedIndex(index)}
            onCheckboxChange={() => handleCheckboxChange(value)}
            onValueClick={() => handleValueClick([value])}
          />
        ))}
      </ul>
    </div>
  );
};

export default FilterValues;
